import React from 'react';

import {DatePicker} from 'antd';

import {buildRequestFromDate, formatDateFromParams, nextPeriod, prevPeriod} from '../../utils/builders/date-builder';
import {Property} from 'csstype';

import './Title.css';
import parse from 'url-parse';

//import { RangePickerValue } from 'antd/lib/date-picker/interface';
import URLBuilder, {Period} from '../../builders/URLBuilder';

import MediaQuery from 'react-responsive';
import {ButtonGroup, Item as ButtonGroupItem} from '../Views/ButtonGroup';
import {useTranslation} from "@nic-react-i18n/core";
import {useLocation, useNavigate, useParams} from "react-router";
import {RangePickerProps} from "antd/lib/date-picker";
import {convertDate, formatter} from "../../utils";
import itIT from "antd/lib/calendar/locale/it_IT";
import enEN from "antd/lib/calendar/locale/en_GB";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

/*
const formatter: Record<string,Intl.DateTimeFormatOptions> = {
    day: CALENDAR_DATE_CONF,
    month: MONTH_CONF,
    week: WEEK_CONF,
    year: YEAR_CONF
};
*/
interface TitleProps {
    locale?: string;
    requestCalendar: boolean;
    baseURI?: string;
}

const Title: React.FC<TitleProps> = (props) => {
    const {t, locale} = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()
    const params = useParams()
    const getBackground = (period: string, selection: string) => {
        return (period === selection ? 'rgb(217, 234, 253)' : 'transparent');
    }

    const buildDateLabel = (next: dayjs.Dayjs, period?: string): string => {
        //console.log('buildDateLabel: period: ', period)


        let res: string;
        switch (period) {
            case 'day':
            case 'month':
                let d1 = convertDate(locale, dayjs(next).toDate(), formatter[period])
                res = `${t(`title.${period}`)} ${d1}`;
                break
            case 'week':
                let d2 = dayjs(next).format('WW / YYYY');
                res = `${t(`title.${period}`)} ${d2}`;
                break;
            case 'range':
                res = '';
                break;
            default:
                res = convertDate(locale, dayjs(next).toDate(), formatter['year'])
                break;
        }
        return res;
    }

    const renderTitle = (direction: Property.FlexDirection, buttonDirection: Property.FlexDirection) => {
        const fullPath = location.pathname + location.search;
        const { requestCalendar, baseURI} = props;
        const url = parse(fullPath, true);

        let title;

        //console.log('RenderTitle: ', params.period)


        switch (params.period) {
            case 'week': {
                title = t('title.week') + ' ' +
                    params.month + t('title.of') + params.year;

                break;
            }
            case 'range': {

                title = t('title.range', {from: url.query.from, to: url.query.to});
                break;
            }

            default: {
                const date = formatDateFromParams(params,  url.query);
                title = convertDate(locale, date.toDate(), formatter[params.period??'year'])
                    //moment(date).format(formatter[params.period??'year']);
                break;
            }
        }

        const nextDate = nextPeriod(params);
        const prevDate = prevPeriod(params);

        const justifyRight = (direction === 'row' ? 'flex-end' : 'center');
        const justifyLeft = (direction === 'row' ? 'flex-start' : 'center');
        const padding = (direction === 'row' ? '0px' : '10px');
        const justifyContent = (direction === 'row' ? 'space-between' : 'center');
        return (
            <div>

                <div
                    className="header-toolbar"
                    style={{
                        display: 'flex',
                        flexDirection: direction,
                        justifyContent: justifyContent,
                        alignContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center'
                    }}
                >
                    <div className="header-toolbar-item" style={{paddingTop: padding}}>
                        {!requestCalendar &&
                            <div style={{display: 'flex', justifyContent: justifyLeft}}>
                        <ButtonGroup direction={buttonDirection}>

                            <ButtonGroupItem
                                style={{
                                    backgroundColor: (getBackground(params.period??'day', 'day')),
                                    borderRight: '1px solid rgb(233, 233, 233)'
                                }}
                                onClick={() => {
                                    navigate(
                                        buildRequestFromDate(
                                            {
                                                query: url.query,
                                                period: 'day',
                                            },
                                            dayjs(formatDateFromParams(params.period, url.query))
                                        ));
                                }}
                            >
                                <span style={{padding: '5px'}}>
                                {t('calendar.header.day')}
                                </span>
                            </ButtonGroupItem>
                            <ButtonGroupItem
                                style={{
                                    backgroundColor: (getBackground(params.period??'week', 'week')),
                                    borderRight: '1px solid rgb(233, 233, 233)'
                                }}
                                onClick={() => {
                                    navigate(
                                        buildRequestFromDate(
                                            {
                                                query: url.query,
                                                period: 'week',
                                                kind: params.kind
                                            },
                                            dayjs(formatDateFromParams(params, url.query))
                                        ));
                                }}
                            >
                                <span style={{padding: '5px'}}>
                                {t('calendar.header.week')}
                                </span>
                            </ButtonGroupItem>
                            <ButtonGroupItem
                                style={{
                                    backgroundColor: (getBackground(params.period??'month', 'month')),
                                    borderRight: '1px solid rgb(233, 233, 233)'
                                }}
                                onClick={() => {
                                    navigate(
                                        buildRequestFromDate(
                                            {
                                                query: url.query,
                                                period: 'month',
                                                kind: params.kind
                                            },
                                            dayjs(formatDateFromParams(params, url.query))
                                        )
                                    );
                                }}
                            >
                                <span style={{padding: '5px'}}>
                                {t('calendar.header.month')}
                                </span>
                            </ButtonGroupItem>

                            <ButtonGroupItem
                                style={{backgroundColor: (getBackground(params.period?? 'year', 'year'))}}
                                onClick={() => {
                                   navigate(
                                        buildRequestFromDate(
                                            {
                                                query: url.query,
                                                period: 'year',
                                                kind: params.kind
                                            },
                                            dayjs(formatDateFromParams(params, url.query))
                                        ));
                                }}
                            >
                                <span style={{padding: '5px'}}>
                                {t('calendar.header.year')}
                                </span>
                            </ButtonGroupItem>
                        </ButtonGroup>
                            </div>
                        }
                    </div>
                    <div className={'header-toolbar-item'}  style={{paddingTop: padding}}>
                        {!requestCalendar &&
                        <RangePicker
                            locale={locale=== 'it' ? itIT: enEN}
                            defaultPickerValue={
                                (url.query.from !== undefined && url.query.to !== undefined) ?
                                    [dayjs(url.query.from), dayjs(url.query.to)] :
                                    undefined
                            }
                            onChange={(dates:  RangePickerProps['value'], dateStrings: [string, string]) => {

                                const start = dayjs(dateStrings[0]);
                                const end = dayjs(dateStrings[1]);
                                if (dates && dates.length=== 2) {

                                    let urlBuilder: URLBuilder = new URLBuilder();
                                    let res =
                                        urlBuilder.buildBooking().period(Period.RANGE).addRange(start, end).build();

                                    navigate(res);

                                }

                            }
                            }
                        />
                        }
                    </div>
                    <div className="header-toolbar-item"  style={{paddingTop: padding}}>
                        <div style={{display: 'flex', justifyContent: justifyRight}}>
                        <ButtonGroup direction={buttonDirection}>
                            <ButtonGroupItem
                                style={{borderRight: '1px solid rgb(233, 233, 233)'}}
                                disabled={params.period === 'range'}
                                onClick={() => {
                                    navigate(
                                        buildRequestFromDate(params, prevDate, baseURI)
                                    );
                                }}
                            >
                                <span style={{padding: '5px'}}>
                                <div
                                    style={{
                                        marginTop: 'auto', marginBottom: 'auto', textAlign: 'center',
                                        display: 'flex', alignItems: 'center'
                                    }}
                                >

                                    <i className={'fal fa-angle-left'}/>
                                    <div style={{paddingLeft: '10px'}}>
                                        {buildDateLabel(prevDate, params.period)}
                                    </div>

                                </div>
                                </span>
                            </ButtonGroupItem>
                            <ButtonGroupItem
                                disabled={params.period === 'range'}
                                onClick={() => {
                                    navigate(
                                        buildRequestFromDate(params, nextDate, baseURI)
                                    );
                                }}
                            >
                                <span style={{padding: '5px'}}>
                                <div
                                    style={{
                                        marginTop: 'auto', marginBottom: 'auto', textAlign: 'center',
                                        display: 'flex', alignItems: 'center'
                                    }}
                                >

                                    <div style={{paddingRight: '10px'}}>
                                        {buildDateLabel(nextDate, params.period)}
                                    </div>
                                    <i className={'fal fa-angle-right'}/>

                                </div>
                                </span>
                            </ButtonGroupItem>
                        </ButtonGroup>
                        </div>
                    </div>
                </div>

                <div className="title">{title}</div>
            </div>
        );
    }

        return (
            <span>
                <MediaQuery minWidth={930}>
                    {renderTitle('row', 'row')}
                </MediaQuery>
                <MediaQuery minWidth={400} maxWidth={929}>
                    {renderTitle('column',  'row')}
                </MediaQuery>
                <MediaQuery minWidth={300} maxWidth={399}>
                    {renderTitle('column',  'column')}
                </MediaQuery>
            </span>
        );

}
export default Title;